import React, { useState } from "react";

import { FormContext } from "@/pages/_app";
import dynamic from "next/dynamic";

const TechnologyNew = dynamic(() => import("./technologies-new/technology"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});

const TechnologyPage = (props: any) => {
  const slug = props.slug;

  const [showModal, setShowModal] = useState(false);
  const technologyFormContext = {
    showModal,
    showForm: () => setShowModal(true),
    hideForm: () => setShowModal(false),
  };

  const sdata = props.data;

  const data = sdata.data[0]?.attributes;
  // const design = sdata.data[0]?.attributes?.design;
  const seo = sdata.data[0]?.attributes.seo;
  const blocks = sdata.data[0]?.attributes.blocks;

  const SwitchCase = (props: any) => {
    return <TechnologyNew {...props} />;
  }

  return (
    <>
      {seo && <HocHead seo={seo} />}

      <FormContext.Provider value={technologyFormContext}>
        <SwitchCase
          blocks={blocks}
          slug={slug}
          type="Technology"
          breadcrumbs={data?.breadcrumbs ?? {}}
          title={data?.title ?? data?.Title ?? ""}
        />
      </FormContext.Provider>
    </>
  );
};

export default TechnologyPage;
